import { Component, Input } from '@angular/core';

@Component({
  selector: 'nx-ng-validation-success',
  templateUrl: './validation-success.component.html',
  styleUrls: ['./validation-success.component.scss'],
})
export class ValidationSuccessComponent {
  @Input()
  labelKey = '';
}
